export default __webpack_public_path__ + "static/media/aglogo.ec284fc8.png";